import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * NIGHT AUDIT API CONFIGURATION
 * Keys match controllers exposed by /api/v1/night-audit
 */

export const nightAuditConfig = {
  /* -------------------------------- GET ---------------------------------- */
  getNightAudits: {
    key: "getNightAudits",
    url: "/api/v1/night-audit",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
      staleTime: STALE_TIME.SLOW,
      gcTime: GC_TIME.LONG,
    },
  },

  /* -------------------------------- POST --------------------------------- */
  createNightAudit: {
    key: "createNightAudit",
    url: "/api/v1/night-audit",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getNightAudits"],
    },
  },

  runNightAudit: {
    key: "runNightAudit",
    url: "/api/v1/night-audit/run",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getNightAudits",
        "getAllHousekeepingTasks",
        "getAllInspections",
      ],
    },
  },
};
